import type React from "react";
import {
  Item as ShadcnItem,
  ItemMedia as ShadcnItemMedia,
  ItemContent as ShadcnItemContent,
  ItemActions as ShadcnItemActions,
  ItemGroup as ShadcnItemGroup,
  ItemSeparator as ShadcnItemSeparator,
  ItemTitle as ShadcnItemTitle,
  ItemDescription as ShadcnItemDescription,
  ItemHeader as ShadcnItemHeader,
  ItemFooter as ShadcnItemFooter,
} from "src/shadcn/components/item";

const Item = (props: React.ComponentProps<typeof ShadcnItem>) => (
  <ShadcnItem {...props} />
);

const ItemMedia = (props: React.ComponentProps<typeof ShadcnItemMedia>) => (
  <ShadcnItemMedia {...props} />
);

const ItemContent = (props: React.ComponentProps<typeof ShadcnItemContent>) => (
  <ShadcnItemContent {...props} />
);

const ItemActions = (props: React.ComponentProps<typeof ShadcnItemActions>) => (
  <ShadcnItemActions {...props} />
);

const ItemGroup = (props: React.ComponentProps<typeof ShadcnItemGroup>) => (
  <ShadcnItemGroup {...props} />
);

const ItemSeparator = (
  props: React.ComponentProps<typeof ShadcnItemSeparator>
) => <ShadcnItemSeparator {...props} />;

const ItemTitle = (props: React.ComponentProps<typeof ShadcnItemTitle>) => (
  <ShadcnItemTitle {...props} />
);

const ItemDescription = (
  props: React.ComponentProps<typeof ShadcnItemDescription>
) => <ShadcnItemDescription {...props} />;

const ItemHeader = (props: React.ComponentProps<typeof ShadcnItemHeader>) => (
  <ShadcnItemHeader {...props} />
);

const ItemFooter = (props: React.ComponentProps<typeof ShadcnItemFooter>) => (
  <ShadcnItemFooter {...props} />
);

export {
  Item,
  ItemMedia,
  ItemContent,
  ItemActions,
  ItemGroup,
  ItemSeparator,
  ItemTitle,
  ItemDescription,
  ItemHeader,
  ItemFooter,
};
